// src/Shop/Shop.js

import React, { useState, useContext, useEffect, useMemo } from "react";
import Header from "../components/Header";
import Footer from "../components/Footer";
import Product from "./Product";
import { CartContext } from "../context/CartContext";
import { getActiveProducts } from "../Services/productService";
import "./Shop.css";

export default function Shop({ navigateTo }) {
  // گرفتن تابع addProductToCart از Context
  const { addProductToCart } = useContext(CartContext);

  // state برای نگهداری متن جستجو
  const [searchTerm, setSearchTerm] = useState("");

  // محصولات از db.json دریافت می‌شوند
  const [products, setProducts] = useState([]);
  const [productsLoading, setProductsLoading] = useState(true);
  const [productsError, setProductsError] = useState("");

  useEffect(() => {
    loadProducts();
  }, []);

  const loadProducts = async () => {
    try {
      setProductsLoading(true);
      setProductsError("");

      const productsFromServer = await getActiveProducts();

      setProducts(Array.isArray(productsFromServer) ? productsFromServer : []);
    } catch (error) {
      console.error("خطا در دریافت محصولات:", error);
      setProductsError(
        "خطا در دریافت محصولات. لطفاً مطمئن شوید سرور با npm run server فعال است."
      );
      setProducts([]);
    } finally {
      setProductsLoading(false);
    }
  };

  // فیلتر محصولات بر اساس جستجو
  const filteredProducts = useMemo(() => {
    const search = searchTerm.trim().toLowerCase();

    if (!search) return products;

    return products.filter((product) => {
      return (
        product.title?.toLowerCase().includes(search) ||
        product.description?.toLowerCase().includes(search) ||
        product.category?.toLowerCase().includes(search)
      );
    });
  }, [products, searchTerm]);

  // اضافه کردن به سبد سفارش
  const handleAddToCart = (productId) => {
    const product = products.find(
      (item) => String(item.id) === String(productId)
    );

    if (product) {
      addProductToCart(product, products);
    }
  };

  // پاک کردن جستجو
  const clearSearch = () => {
    setSearchTerm("");
  };

  // اجرای جستجو با دکمه ذره‌بین
  const handleSearch = () => {
    // جستجو همزمان با تایپ انجام می‌شود.
    // این تابع برای توسعه‌های بعدی نگه داشته شده است.
  };

  return (
    <>
      <Header navigateTo={navigateTo} />

      {/* بخش جستجو */}
      <div className="container">
        <div className="search-section">
          <div className="search-wrapper">
            {/* دکمه clear در سمت چپ */}
            {searchTerm && (
              <button
                type="button"
                className="clear-search-btn"
                onClick={clearSearch}
                title="پاک کردن جستجو"
              >
                ✕
              </button>
            )}

            <input
              type="text"
              className="search-input"
              placeholder=" جستجوی محصول ..."
              value={searchTerm}
              onChange={(e) => setSearchTerm(e.target.value)}
            />

            <button
              type="button"
              className="search-btn"
              onClick={handleSearch}
            >
              🔍
            </button>
          </div>
        </div>
      </div>

      <section className="container content-section">
        {productsLoading ? (
          <div className="no-results">
            <span className="no-results-icon">⏳</span>
            <p className="no-results-text">در حال دریافت محصولات...</p>
          </div>
        ) : productsError ? (
          <div className="no-results">
            <span className="no-results-icon">⚠️</span>
            <p className="no-results-text">{productsError}</p>

            <button
              type="button"
              className="search-btn"
              onClick={loadProducts}
              style={{ marginTop: "1rem" }}
            >
              تلاش دوباره
            </button>
          </div>
        ) : (
          <div className="shop-items">
            {filteredProducts.length === 0 ? (
              <div className="no-results">
                <span className="no-results-icon">🔍</span>
                <p className="no-results-text">
                  {searchTerm
                    ? `${searchTerm} یافت نشد`
                    : "محصولی برای نمایش وجود ندارد"}
                </p>
              </div>
            ) : (
              filteredProducts.map((product) => (
                <Product
                  key={product.id}
                  {...product}
                  onAddProduct={handleAddToCart}
                  onProductClick={(id) => navigateTo("product", id)}
                />
              ))
            )}
          </div>
        )}
      </section>

      <Footer navigateTo={navigateTo} />
    </>
  );
}